import React from 'react'
import PendingChart from '../../../../../Portfolio_R/SummaryCharts/components/PendingChart'

const PendingCard = ({ firstData, firstTitle, secondTitle, secondData }) => {
    return (
        <div className="pending">
            <div className="c-pending">
                <PendingChart
                    title={firstTitle}
                    value={firstData}
                />
                <PendingChart
                    title={secondTitle}
                    value={secondData}
                />
            </div>
        </div>
    )
}

export default PendingCard